import React from "react";
import {Col, Row} from "antd";
import {WarningOutlined} from "@ant-design/icons";
import {Trans} from "@lingui/macro";

export function NoPermission() {
    // const { accessKeys } = props;
    return (
        <Row align="middle">
            <Col span={24} align="center">
                <p><WarningOutlined /></p>
                <h2><Trans>No Permission to Page</Trans></h2>
            </Col>
        </Row>
    );
}
